document.addEventListener('DOMContentLoaded', () => {
    const colorpickerEl = document.querySelector('[data-colorpicker-component]')
    const labels = new ComponentLabels(document.getElementById('variant-labels'))

    if (colorpickerEl) {
        const colorpicker = new ComponentColorpicker(colorpickerEl)

        colorpicker.onChange = (data) => {
            labels.set({
                title: { value: data.title, show: true },
                notAvailable: { value: data.unavailableLabel, show: data.available != 'true' },
                outOfStock: { value: data.outOfStockLabel, show: data.available == 'true' && data.outOfStock == 'true' },
                inStock: { value: data.inStockLabel, show: data.available == 'true' && data.outOfStock == 'false' },
                nextIncomingDate: {
                    value: 'Next arrival: ' + data.nextIncomingDate,
                    show: (!data.available == 'true' || data.outOfStock == 'true') && data.nextIncomingDate != false,
                },
            })
        }
    } else {
        FORMSIMPLE.onChange = (data) => {
            labels.set({
                notAvailable: { value: data.unavailableLabel, show: data.available != 'true' },
                inStock: { value: data.inStockLabel, show: data.available == 'true' && data.outOfStock == 'false' },
                outOfStock: { value: data.outOfStockLabel, show: data.available == 'true' && data.outOfStock == 'true' },
                nextIncomingDate: {
                    value: 'Next arrival: ' + data.nextIncomingDate,
                    show: (!data.available == 'true' || data.outOfStock == 'true') && data.nextIncomingDate != false,
                },
            })
        }
    }

    // const imageZooms = document.querySelectorAll('[data-zoom-image-url]')
    // imageZooms.forEach((el) => {
    //     new ImageZoom(el)
    // })
})

// class ImageZoom {
//     // el should be a swiper slide or a direct parent with relative position
//     constructor(el) {
//         this.root = el
//         this.zoomImageUrl = el.dataset.zoomImageUrl
//         this.baseImageEl = el.querySelector('img')
//         this.isZoomed = false

//         this.bindUIEvents()
//     }

//     bindUIEvents() {
//         this.root.addEventListener('click', this.onClick.bind(this))
        
//     }

//     onClick(e) {
//         if (this.isZoomed) {
//             this.isZoomed = false
//             this.zoomOut(e)
//             this.root.removeEventListener('mousemove', this.onMouseMove.bind(this))
//         }
//         else {
//             this.isZoomed = true
//             this.zoomIn(e)
//             this.root.addEventListener('mousemove', this.onMouseMove.bind(this))
//         }
//     }

//     zoomIn(e) {
//         this.baseImageEl.classList.add('image-zoom__zoom-image')
//         this.baseImageEl.style.transformOrigin = `${e.offsetX}px ${e.offsetY}px`
//         this.baseImageEl.style.transform = `scale(2)`
//         const highResImage = new Image()
//         highResImage.src = this.zoomImageUrl
//         highResImage.onload = () => {
//             this.baseImageEl.src = highResImage.src
//             this.baseImageEl.srcset = `${highResImage.src} ${highResImage.naturalWidth}w`
//         }
//     }

//     zoomOut(e) {
//         this.baseImageEl.style.transform = 'scale(1)'
//         window.setTimeout(() => {
//             this.baseImageEl.classList.remove('image-zoom__zoom-image')
//         }, 200)
//     }

//     onMouseMove(e) {
//         if (this.isZoomed) {
//             window.requestAnimationFrame(() => {
//                 this.baseImageEl.style.transformOrigin = `${e.offsetX}px ${e.offsetY}px`
//             })
//         }
//     }
// }


class ComponentColorpicker {
	constructor(rootEl) {
		this.rootEl = rootEl
		this.inputEl = document.getElementById(rootEl.dataset.inputId)
		this.colorEls = rootEl.querySelectorAll('[data-colorpicker-color]')

		this.labelsEl = rootEl.querySelector('.colorpicker__labels')
		this.selectedOptionEl = this.inputEl.options[this.inputEl.selectedIndex]

		this.onChange = null

		this.bindUIActions()
	}

	bindUIActions() {
		this.inputEl.addEventListener('change', e => this.handleChange(e))
		this.colorEls.forEach((colorEl) => {
			colorEl.addEventListener('click', e => this.handleClick(e, colorEl))
		})
	}

	handleChange(e) {
		this.selectedOptionEl = this.inputEl.options[this.inputEl.selectedIndex]

		this.colorEls.forEach((colorEl) => {
			if (colorEl.dataset.variantId === this.selectedOptionEl.value) {
				colorEl.classList.add('selected')
			} else {
				colorEl.classList.remove('selected')
			}
		})

		if (this.onChange) this.onChange(this.selectedOptionEl.dataset)
	}

	handleClick(e, colorEl) {
		e.preventDefault()
		this.inputEl.value = colorEl.dataset.variantId
		this.inputEl.dispatchEvent(new Event('change'))
	}
}

class ComponentLabels {
	constructor(rootEl) {
		this.labels = {
			inStock: { value: rootEl.querySelector('[data-in-stock]'), show: false },
			productTitle: { value: rootEl.querySelector('[data-product-title]'), show: false },
			title: { value: rootEl.querySelector('[data-title]'), show: false },
			price: { value: rootEl.querySelector('[data-price]'), show: false },
			compareAtPrice: { value: rootEl.querySelector('[data-compare-at-price]'), show: false },
			included: { value: rootEl.querySelector('[data-included]'), show: false },
			notAvailable: { value: rootEl.querySelector('[data-not-available]'), show: false },
			outOfStock: { value: rootEl.querySelector('[data-out-of-stock]'), show: false },
			nextIncomingDate: { value: rootEl.querySelector('[data-next-incoming-date]'), show: true },
		}

		for (let key in this.labels) {
			this.labels[key].show = this.labels[key].value ? (!this.labels[key].value.classList.contains('hide')) : null
		}
	}

	set(data) {
		for (let [key, d] of Object.entries(data)) {
			if (this.labels[key].value) this.labels[key].value.innerHTML = d.value
			if (this.labels[key].value) this.labels[key].value.classList.toggle('hide', !d.show)
		}
	}
}